module.exports = __webpack_public_path__ + "static/media/greyhoundracing.9032d240.svg";